import React from "react";
import { formatRefreshAgeHours } from "./refreshAgeDisplay";
import { BUY_REC_REFRESH_MIN_INTERVAL_HOURS } from "./stockBuyRecRefreshPolicy";

const listStyle = {
  margin: "0 0 12px 0",
  paddingLeft: "18px",
  fontSize: "13px",
};

const sectionTitleStyle = {
  fontWeight: 600,
  margin: "10px 0 4px 0",
  fontSize: "13px",
};

function formatFilterRefreshAgeLabel(yahooLastRefreshedAt, { neverLabel = "never refreshed" } = {}) {
  const age = formatRefreshAgeHours(yahooLastRefreshedAt);
  if (age) return ` (${age} ago)`;
  if (neverLabel) return ` (${neverLabel})`;
  return "";
}

function renderFilterListItem(filter, ageOptions) {
  return (
    <li key={filter.id || filter.name}>
      {filter.name || filter.id}
      {formatFilterRefreshAgeLabel(filter.yahooLastRefreshedAt, ageOptions)}
    </li>
  );
}

/**
 * Confirmation body for refresh-all: which buy lists will run vs skip (within interval).
 */
export function StockBuyRecRefreshConfirmMessage({ toRefresh, skipped }) {
  const refreshNames = [...(toRefresh || [])].sort((a, b) =>
    String(a.name || "").localeCompare(String(b.name || ""))
  );
  const skippedNames = [...(skipped || [])].sort((a, b) =>
    String(a.name || "").localeCompare(String(b.name || ""))
  );

  return (
    <div>
      <p style={{ margin: "0 0 8px 0" }}>
        Refresh stale buy watchlists from Yahoo Finance? Lists updated within the last {BUY_REC_REFRESH_MIN_INTERVAL_HOURS}{" "}
        hours are skipped.
      </p>
      {refreshNames.length > 0 ? (
        <>
          <p style={sectionTitleStyle}>Will refresh ({refreshNames.length})</p>
          <ul style={listStyle}>
            {refreshNames.map((f) => renderFilterListItem(f, { neverLabel: "never refreshed" }))}
          </ul>
        </>
      ) : null}
      {skippedNames.length > 0 ? (
        <>
          <p style={sectionTitleStyle}>
            Skipped — updated within {BUY_REC_REFRESH_MIN_INTERVAL_HOURS} hours ({skippedNames.length})
          </p>
          <ul style={listStyle}>
            {skippedNames.map((f) => renderFilterListItem(f, { neverLabel: null }))}
          </ul>
        </>
      ) : null}
    </div>
  );
}

export function buildBuyRecAllFreshAlertMessage(skipped) {
  const names = [...(skipped || [])]
    .sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")))
    .map((f) => f.name || f.id)
    .filter(Boolean);
  const list = names.length ? `\n\n${names.join("\n")}` : "";
  return `All buy watchlists were updated within the last ${BUY_REC_REFRESH_MIN_INTERVAL_HOURS} hours. Nothing to refresh.${list}`;
}

export function buildBuyRecSingleFreshAlertMessage(filterName, yahooLastRefreshedAt) {
  const age = formatRefreshAgeHours(yahooLastRefreshedAt);
  const label = filterName || "This watchlist";
  return age
    ? `${label} was updated ${age} ago (within the last ${BUY_REC_REFRESH_MIN_INTERVAL_HOURS} hours). No refresh needed.`
    : `${label} was updated within the last ${BUY_REC_REFRESH_MIN_INTERVAL_HOURS} hours. No refresh needed.`;
}
